import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { NotificationState } from '../../actions/notification/types';
import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

export const useNotification: HookStateFunction<NotificationState | null, void> = createStateHook(
	store,
	{
		selector: (state: IssueAdjustmentsState) => state.notification,
	},
);
